import React, {CSSProperties} from "react";

interface IProps {
    style?: CSSProperties;
}

export const HologicLogo: React.FC<IProps> = ({style}: IProps) => {
    
    return (
        <svg style={style} className="hologic-logo" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 778.1 140.5">
            <g id="g18">
                <path id="path4" className="st0" d="M102.6,58.8H82c0,0,0,42.2,0,48.8c-6.4,0-51.1,0-57.5,0
			c0-6.6,0-48.8,0-48.8H0v126.6h24.5c0,0,0-49.3,0-56.1c6.4,0,51.1,0,57.5,0c0,6.7,0,56.1,0,56.1h24.5V58.8H102.6"/>
                <path id="path6" className="st0" d="M232.3,88.6c-5.2-10-13-17.9-22.9-23.5
			c-9.9-5.5-21.1-8.3-33.4-8.3c-18.8,0-34.3,6-46.3,17.9c-11.9,11.9-18,28.3-18,49c0,10.9,2.6,21.5,7.7,31.3
			c5.1,10,12.8,18,22.7,23.7s21.3,8.6,33.8,8.6c11.5,0,22.4-2.6,32.4-7.8c10.1-5.3,18.1-13,23.6-23.1c5.4-10,8.2-21.5,8.2-34.1
			C240.1,109.8,237.5,98.5,232.3,88.6 M215.3,122.3c0,14.1-3.7,25.1-11.1,32.6c-7.4,7.6-16.7,11.3-28.3,11.3
			c-11.4,0-20.6-3.7-28.1-11.2c-7.4-7.4-11.1-17.9-11.1-31.1c0-16.6,3.9-28.5,11.5-35.3c7.9-7,17-10.4,28-10.4
			c7.6,0,14.5,1.8,20.6,5.4s10.6,8.5,13.7,15.1C213.6,105.3,215.3,113.2,215.3,122.3L215.3,122.3z"/>
                <path id="path8" className="st0" d="M269.8,163.6c0-7.2,0-104.8,0-104.8h-24.5v126.6h86.4v-21.7
			C331.8,163.6,276.7,163.6,269.8,163.6"/>
                <path id="path10" className="st0" d="M439.9,88.6c-5.2-10-12.9-17.9-22.9-23.5
			c-9.9-5.5-21.1-8.3-33.4-8.3c-18.8,0-34.3,6-46.2,17.9c-12,11.9-18,28.3-18,49c0,11,2.6,21.5,7.7,31.3c5.1,10,12.8,18,22.8,23.7
			c9.9,5.7,21.2,8.6,33.7,8.6c11.5,0,22.4-2.6,32.4-7.8c10.1-5.2,18.1-13,23.6-23.1c5.5-10,8.2-21.5,8.2-34.1
			C447.7,109.8,445.1,98.5,439.9,88.6 M422.9,122.3c0,14.1-3.7,25.1-11.1,32.6c-7.4,7.6-16.7,11.3-28.3,11.3
			c-11.4,0-20.6-3.7-28.1-11.2s-11.1-17.7-11.1-31.1c0-16.6,3.9-28.5,11.5-35.3c7.9-7,17-10.4,28-10.4c7.6,0,14.5,1.8,20.6,5.4
			s10.6,8.5,13.7,15.1S422.9,113.2,422.9,122.3L422.9,122.3z"/>
                <path id="path12" className="st0" d="M517,117v21.7c0,0,30.8,0,37,0c0,4.7,0,13.6,0,16.3
			c-3.2,2.4-7.5,4.7-13.2,6.9c-6.4,2.4-13.1,3.7-19.7,3.7c-7.7,0-15.1-1.6-21.9-4.8c-6.7-3.1-11.6-7.8-15.1-14.2
			c-3.5-6.5-5.3-14.8-5.3-24.7c0-8,1.5-15.5,4.5-22.4c1.7-3.8,4.1-7.4,7.2-10.6c3-3.1,7.1-5.7,12.1-7.7c5.1-2,11.2-3,18.3-3
			c5.8,0,11.2,1,15.9,2.8c4.5,1.8,8.1,4.2,10.4,7.1c2.5,3.1,4.6,7.4,6.3,13l1.1,3.5l22.4-5.9l-1-3.8c-2.3-8.5-5.8-15.5-10.3-20.9
			c-4.6-5.5-11-9.8-18.9-12.8c-7.8-2.9-16.5-4.4-26.1-4.4c-13.1,0-24.9,2.6-35,7.7c-10.3,5.2-18.4,13.3-23.8,24
			c-5.4,10.5-8.1,22-8.1,34.1c0,12.3,2.8,23.6,8.2,33.5c5.5,10.1,13.8,17.9,24.6,23.3c10.6,5.2,22.5,7.9,35.4,7.9
			c9.6,0,19-1.6,28.1-4.9c9-3.2,17.9-8.1,26.4-14.5l1.6-1.2V117H517"/>
                <polyline id="polyline14" className="st0"
                          points="608.6,58.8 588,58.8 588,185.4 612.5,185.4 612.5,58.8 608.6,58.8 		"/>
                <path id="path16" className="st0" d="M715.4,135.2l-0.9,3.8c-2.1,9-6,15.9-11.8,20.4
			c-5.8,4.6-12.8,6.8-21.3,6.8c-7,0-13.5-1.7-19.5-5.1c-5.9-3.3-10.1-8.2-12.9-15c-2.9-7-4.4-15.4-4.4-25c0-7.3,1.2-14.5,3.7-21.4
			c2.4-6.6,6.4-11.8,12.2-15.7c5.8-3.9,13.3-5.9,22.2-5.9c7.6,0,13.9,1.7,18.8,5.2c4.8,3.4,8.7,9.1,11.3,16.9l1.1,3.3l23.8-5.3
			l-1.2-4c-3.6-11.8-10.1-21.1-19.4-27.6c-9.2-6.5-20.7-9.8-34-9.8c-11.7,0-22.6,2.6-32.3,7.6c-9.9,5.1-17.7,12.7-23,22.5
			c-5.3,9.7-8,21.2-8,34.2c0,11.8,2.4,23.1,7,33.4c4.8,10.6,11.8,18.7,20.9,24.3c9.1,5.6,20.9,8.4,35.1,8.4
			c13.9,0,25.9-3.7,35.6-10.9c9.8-7.2,16.6-17.9,20.3-31.6l1.1-3.9L715.4,135.2"/>
            </g>
            <g id="g22">
                <path id="path20" className="st0" d="M754.6,87.6c-8,0-13.6-6-13.6-13.8c0-8.3,6.3-13.8,13.6-13.8
			s13.5,5.5,13.5,13.8S761.8,87.6,754.6,87.6z M754.6,62.4c-6,0-10.7,4.7-10.7,11.4c0,6.3,4.1,11.4,10.7,11.4
			c5.9,0,10.6-4.7,10.6-11.4C765.1,67.1,760.5,62.4,754.6,62.4z M751.8,81.7h-2.5V66.4h5.8c3.7,0,5.6,1.3,5.6,4.4
			c0,2.8-1.7,3.9-4,4.2l4.3,6.7h-2.9l-4-6.6h-2.4v6.6H751.8z M754.6,73c1.9,0,3.6-0.2,3.6-2.4c0-1.9-1.8-2.1-3.3-2.1h-3V73H754.6z"
                />
            </g>
        </svg>
    );
};
